import logo from './logo.svg';
import './App.css';

import React, { useEffect, useState } from 'react';
import * as API from './api/api';

function App() {

  const [userName, setUserName] = useState(localStorage.getItem('userName') ||  null);
  const [email, setEmail] = useState(localStorage.getItem('email') ||  null);
  const [userToken, setUserToken] = useState(localStorage.getItem('userToken') || null);
  const [sessionCode, setSessionCode] = useState(localStorage.getItem('sessionCode') || '');

  const [sessionData, setSessionData] = useState(null);


  function handleRegistration(event) {
    event.preventDefault();
    const name = document.getElementById('name').value;
    const email = document.getElementById('email').value;

    API.Register(name, email).then(response => {
      if(response.status){
        setUserName(name);
        setEmail(email);
        localStorage.setItem('userName', name);
        localStorage.setItem('email', email);
      }
    });
  }

  function CapturePINCode(event, i) {
     const value = event.target.value;
     const charInputs = Array.from(document.querySelectorAll('.one-char-input'));

     if (value.length === 1 && i < charInputs.length - 1) {
          document.querySelector(`[data-index="${i + 1}"]`).focus();
      }
      // check if all inputs are filled
      const allFilled = Array.from(document.querySelectorAll('.one-char-input')).every(input => input.value.length === 1);
      if (allFilled) {
          const pin = Array.from(document.querySelectorAll('.one-char-input')).map(input => input.value).join('');
          console.log('Entered PIN:', pin);

          API.ConfirmUser(email, pin).then(response => {
            if (response.userToken) {
              setUserToken(response.userToken);
              localStorage.setItem('userToken', response.userToken);
            } else {
              document.getElementById('invalidPIN').style.display = 'block';
              // Clear inputs for retry
              document.querySelectorAll('.one-char-input').forEach(input => input.value = '');
              document.querySelector(`[data-index="0"]`).focus();
            }
          });
      }
  }
  function CaptureSessionCode(event, i) 
  {
     const value = event.target.value;
     const charInputs = Array.from(document.querySelectorAll('.one-char-input'));

     if (value.length === 1 && i < charInputs.length - 1) {
          document.querySelector(`[data-index="${i + 1}"]`).focus();
      }
      // check if all inputs are filled
      const allFilled = Array.from(document.querySelectorAll('.one-char-input')).every(input => input.value.length === 1);
      if (allFilled) {
          const code = Array.from(document.querySelectorAll('.one-char-input')).map(input => input.value).join('');
          console.log('Entered Session Code:', code);

          API.LoadSession(code).then(response => {
            if (response.success) {
              setSessionCode(response.sessionCode);
              localStorage.setItem('sessionCode', response.sessionCode);
            } else {
              document.getElementById('statusMessage').style.display = 'block';
              // Clear inputs for retry
              document.querySelectorAll('.one-char-input').forEach(input => input.value = '');
              document.querySelector(`[data-index="0"]`).focus();
            }
          });
      }
  }

  useEffect(() => {
    setTimeout(() => {
      const firstInput = document.querySelector(`[data-index="0"]`);
      if (firstInput) {
        firstInput.focus();
      } 
    }, 300);

      if(sessionCode) {
        API.GetSessionData(sessionCode).then(response => {
          console.log('API Response:', response);
          //if (response.success) {
            setSessionData(response);
            //console.log('Session Data:', response.data);
          //} else {
          //  console.error('Failed to load session data');
         //s }
        });
      }
      
    }, [userName, userToken, sessionCode]);

    function toggleButton(event, quizId, answerId) {
      const button = event.target;
      const quiz = button.getAttribute('data-quiz');
      const answer = button.getAttribute('data-answer');
      console.log(`Quiz ${quiz}, Answer ${answer} selected`);

      if (button.classList.contains('selected')) {
        button.classList.remove('selected');
      } else {
        button.classList.add('selected');
      }
    }

    function submitAnswers() {
      const selectedAnswers = [];
      document.querySelectorAll('.answer-btn.selected').forEach(button => {
        const quiz = button.getAttribute('data-quiz');
        const answer = button.getAttribute('data-answer');
        selectedAnswers.push({ quiz, answer });
      });
      console.log('Submitting answers:', selectedAnswers);
      // Here you would typically send the selected answers to the server via an API call
    } 

    function askForLogout() {
      if (window.confirm('Are you sure you want to log out?')) {
        setUserName(null);
        setUserToken(null);
        setSessionCode('');
        setSessionData(null);
        localStorage.removeItem('userName');
        localStorage.removeItem('userToken');
        localStorage.removeItem('sessionCode');
      }
    } 

    function askForExitSession() {
      if (window.confirm('Are you sure you want to exit the session?')) {
        setSessionCode('');
        setSessionData(null);
        localStorage.removeItem('sessionCode');
      }
    } 

  return (
    <div className="App">
      {userName && (
      <div id="header">
            {userName && (<div id="user-name" onClick={askForLogout}>{userName}</div>)}
            {sessionCode && (<div id="session-code" onClick={askForExitSession}>{sessionCode}</div>)}
        </div>
        )}
        <div id="content">

          { !userName && (
            <div className="form-container form-container-500 white-background padding20">
                <h2>Register</h2>
                <form id="registrationForm">
                    <div className="form-group">
                        <label for="name">Name</label>
                        <input type="text" id="name" required />
                    </div>
                    <div className="form-group">
                        <label for="email">Email</label>
                        <input type="email" id="email" required />
                    </div>
                    <button type="submit" className="btn-height45" onClick={handleRegistration}>Register</button>
                </form>
                <div className="cookie-consent">
                    By registering, you agree to our use of cookies
                </div>
            </div>
          )}

          { userName && !userToken && (
              <div className="form-container form-container-500 white-background padding20">
                <h2>Enter PIN</h2>
                <p style={{ "text-align": "center", "margin-bottom": "20px", "color": "#666" }}>
                    Enter the 5-digit code sent to your email
                </p>
                <div className="otp-container" id="otpContainer">
                    {Array(5).fill(0).map((_, i) => (
                        <input key={i} type="text" className="one-char-input" maxLength="1" data-index={i} onChange={(e) => CapturePINCode(e, i)} />
                    ))}

                </div>
                <div id="invalidPIN" className="invalid-pin" style={{ "display": "none" }}>
                    Invalid PIN, please try again.
                </div>
              </div>
            )}

          { userToken && !sessionCode && (
            <div className="form-container form-container-500 white-background padding20">
                <h2>Enter Session Code</h2>
                <div className="otp-container" id="otpContainer">
                {Array(6).fill(0).map((_, i) => (
                        <input key={i} type="text" className="one-char-input" maxLength="1" data-index={i} onChange={(e) => CaptureSessionCode(e, i)} />
                    ))}
                </div>
                <div id="statusMessage" className="status-message"></div>
            </div>
          )}

          {sessionCode && !sessionData && (
             <div className="form-container form-container-500white-background padding20">
                <p style={{ textAlign: 'center' }}>Loading session data...</p>
              </div>
          )}

          {sessionData && (
                <div>
                {sessionData.status === 'active' ? (
                  <div>
                    <h3>Quizzes:</h3>
                    <div className="form-container" style={{ maxWidth: '1200px' }}>
                        <div className="quiz-grid" id="quizGrid">
                          {sessionData.quizzes.map((quiz, index) => (
                            <div key={index} className="quiz-card">
                              <div className="quiz-title">Question {quiz.quiz}</div>
                                      <img src={quiz.image} alt={`Question ${quiz.quiz}`} className="quiz-image" onError={() => (document.querySelector('.quiz-image').src = `https://picsum.photos/300/200?random={index}`)} />
                                      <div className="quiz-content">
                                          
                                          <div className="answer-buttons" data-quiz="{quiz.quiz}">
                                              {Array(quiz.answers).fill(0).map((_, i) => (
                                                  <button onClick={(e) => toggleButton(e, quiz.quiz, i + 1)} key={i} 
                                                    className="answer-btn" data-quiz={quiz.quiz} data-answer={i + 1}>
                                                      {i + 1}
                                                  </button>
                                              ))}
                                          </div>
                                      </div>
                                  </div>
                          ))}
                        </div>
                        <div className="submit-container">
                            <button className="submit-btn btn-height45" id="submitAnswers" onClick={submitAnswers}>Submit Answers</button>
                        </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <h2>{sessionData.status}</h2>
                  </div>
                )}
                </div>
          )}
              
          
        </div>
    </div>
  );
}

export default App;
